export const GET_STORE_DATA_START = 'store/GET_STORE_DATA_START';
export const GET_STORE_DATA_COMPLETED = 'store/GET_STORE_DATA_COMPLETED';
export const GET_STORE_DATA_FAILED = 'store/GET_STORE_DATA_FAILED';

export const UPDATE_STORE_SETTINGS_START = 'store/UPDATE_STORE_SETTINGS_START';
export const UPDATE_STORE_SETTINGS_COMPLETED = 'store/UPDATE_STORE_SETTINGS_COMPLETED';
export const UPDATE_STORE_SETTINGS_FAILED = 'store/UPDATE_STORE_SETTINGS_FAILED';

export const SET_SELECTED_PRODUCT = 'store/SET_SELECTED_PRODUCT';
export const CLEAR_SELECTED_PRODUCT = 'store/CLEAR_SELECTED_PRODUCT';
